import { createSlice } from "@reduxjs/toolkit";

import { USER_SETTINGS_KEY } from "core/local_storage_utils";
import { parseJsonString } from "core/str_utils";

const priceOfferHiddenColumns = [{ id: "id" }, { id: "som_item_id" }, { id: "som_status" }, { id: "is_winner" }];

const priceOfferDefaultColumns = [
	{ id: "ksr_code" },
	{ id: "name" },
	{ id: "unit" },
	{ id: "estimate_without_vat" },
	{ id: "company_name" },
	{ id: "company_store_place" },
	{ id: "pricezone_name" },
	{ id: "offer_date" },
	{ id: "kats_date_create" },
];

const initialState = () => {
	const userSettings = parseJsonString(localStorage.getItem(USER_SETTINGS_KEY));

	const priceOfferColumns = [
		"company_id",
		"company_inn",
		"company_kpp",
		"company_name",
		"company_site",
		"company_status",
		"company_store_place",
		"date_create",
		"doc_unit_id",
		"estimate_without_vat",
		"id",
		"is_winner",
		"just_paths",
		"kats_date_create",
		"kats_id",
		"ksr_book_id",
		"ksr_chapter_id",
		"ksr_code",
		"ksr_group_id",
		"ksr_part_id",
		"link_file",
		"name",
		"offer_date",
		"organization_id",
		"price_offer_with_vat",
		"price_offer_without_vat",
		"price_storage_percent",
		"price_storage_price",
		"price_transportation",
		"price_zone_id",
		"pricezone_name",
		"project_code",
		"project_id",
		"project_name",
		"project_price_zone_name",
		"som_item_id",
		"som_status",
		"source_offer_id",
		"source_resource_id",
		"unit",
		"user_id",
		"username",
	];

	return {
		clickedTableRow: null,
		storageSearchParams: {
			ksrGroup: userSettings?.priceOffer?.searchParams?.ksrGroup ?? null,
			ksrGroupUseNeighbour: userSettings?.priceOffer?.searchParams?.ksrGroupUseNeighbour ?? false,
			ksrGroupUseAll: userSettings?.priceOffer?.searchParams?.ksrGroupUseAll ?? true,
			priceZones: userSettings?.priceOffer?.searchParams?.priceZones ?? null,
			priceZonesUseNeighbour: userSettings?.priceOffer?.searchParams?.priceZonesUseNeighbour ?? false,
			priceZonesUseAll: userSettings?.priceOffer?.searchParams?.priceZonesUseAll ?? true,
			periodStart: userSettings?.priceOffer?.searchParams?.periodStart ?? null,
			periodEnd: userSettings?.priceOffer?.searchParams?.periodEnd ?? null,
			periodsUseAll: userSettings?.priceOffer?.searchParams?.periodsUseAll ?? true,
			onlyWinner: userSettings?.priceOffer?.searchParams?.onlyWinner ?? false,
			onlyWithJust: userSettings?.priceOffer?.searchParams?.onlyWithJust ?? false,
		},
		priceOfferColumns,
		selectedColumns: [...(userSettings?.priceOffer?.selectedColumns ?? priceOfferDefaultColumns), ...priceOfferHiddenColumns],
	};
};

export const priceOfferSlice = createSlice({
	name: "priceOffer",
	initialState,
	reducers: {
		setClickedTableRow: (state, { payload }) => {
			state.clickedTableRow = payload;
		},
		setStorageSearchParams: (state, { payload }) => {
			state.storageSearchParams = payload;
		},
		setSelectedColumns: (state, { payload }) => {
			state.selectedColumns = payload;
		},
	},
});

export const { actions: priceOfferActions, reducer: priceOfferReducer } = priceOfferSlice;
